// Recovered compiled webpack factory 76871. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, {
    h: () =>
      function e(t, r, n = 2) {
        if (!r || "object" != typeof r || n <= 0) return r;
        if (t && 0 === Object.keys(r).length) return t;
        let a = { ...t };
        for (let t in r)
          Object.prototype.hasOwnProperty.call(r, t) && (a[t] = e(a[t], r[t], n - 1));
        return a;
      },
  });
}
